module.exports = __webpack_public_path__ + "static/img/cr_header_coffee.867ecaa7.png";